import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      marginLeft: theme.spacing(1),
    },
  })
);
